import { KIGAGU_API_BASE_URL } from '@/libs/serviceUrls'
import axiosKigagu from 'axios'
import axios from '@/libs/axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    show: false,
    baseUrl: KIGAGU_API_BASE_URL,
    brands: [],
    selectedBrands: [],
    categories: [],
    selectedCategories: [],
    content: [],
    checkStatus: 'unmatched', // unmatched, matched, all
    checkedBarcodes: [],
    pagination: {
      from: 0,
      to: 0,
      current_page: 1,
      per_page: 200,
      total: 0,
      last_page: 0,
    },
    searchKey: '',
    searchForm: {
      productContentId: '',
      variantBarcodes: '',
      barcode: '',
      productName: '',
      brandIds: [],
    },
  },
  getters: {
    _show(state) {
      return state.show
    },
    _searchKey(state) {
      return state.searchKey
    },
    _searchForm(state) {
      return state.searchForm
    },
    _brands(state) {
      return state.brands
    },
    _selectedBrands(state) {
      return state.selectedBrands
    },
    _categories(state) {
      return state.categories
    },
    _selectedCategories(state) {
      return state.selectedCategories
    },
    _content(state) {
      if (state.checkStatus === 'matched') {
        return state.content.filter(content =>
          content.variants?.some(variant =>
            state.checkedBarcodes.includes(variant.barcode)
          )
        )
      }
      if (state.checkStatus === 'unmatched') {
        return state.content.filter(content =>
          content.variants?.some(variant =>
            !state.checkedBarcodes.includes(variant.barcode)
          )
        )
      }
      return state.content
    },
    _contentBarcodes(state) {
      // content içindeki tüm variantların barcode'larını tek bir array olarak döndür unique olacak şekilde
      return [...new Set(
        state.content.flatMap(content => (content.variants || [])
          .map(variant => variant.barcode)
          .filter(barcode => barcode !== null && barcode !== undefined && barcode !== '')),
      )]
    },
    _pagination(state) {
      return state.pagination
    },
    _checkedBarcodes(state) {
      return state.checkedBarcodes
    },
    _checkStatus(state) {
      return state.checkStatus
    },
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setSearchKey(state, searchKey) {
      state.searchKey = searchKey
    },
    setSearchForm(state, searchForm) {
      state.searchForm = searchForm
    },
    setBrands(state, brands) {
      state.brands = brands
    },
    addSelectedBrand(state, selectedBrand) {
      if (!state.selectedBrands.includes(selectedBrand)) {
        state.selectedBrands.push(selectedBrand)
      }
    },
    removeSelectedBrand(state, selectedBrand) {
      state.selectedBrands = state.selectedBrands.filter(brand => brand !== selectedBrand)
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    addSelectedCategory(state, selectedCategory) {
      if (!state.selectedCategories.includes(selectedCategory)) {
        state.selectedCategories.push(selectedCategory)
      }
    },
    removeSelectedCategory(state, selectedCategory) {
      state.selectedCategories = state.selectedCategories.filter(category => category !== selectedCategory)
    },
    setContent(state, content) {
      state.content = content
    },
    setPagination(state, pagination) {
      state.pagination = pagination
    },
    setCheckedBarcodes(state, checkedBarcodes) {
      state.checkedBarcodes = checkedBarcodes
    },
    setCheckStatus(state, checkStatus) {
      state.checkStatus = checkStatus
    },
  },
  actions: {
    async setSearchFormBy(context, key) {
      context.commit('setShow', true)
      context.commit('setContent', [])
      context.commit('setSearchKey', key)
      context.commit('setCheckedBarcodes', [])
      const trendyolLink = (context.state.searchForm.productContentId || '').trim()
      const productContentId = trendyolLink.match(/(?:^|[-/])p-(\d+)/)?.[1] || ''
      const variantBarcodes = (context.state.searchForm.variantBarcodes || '').trim()
      const productName = (context.state.searchForm.productName || '').trim()
      const brandIds = context.state.searchForm.brandIds || []
      const barcode = (context.state.searchForm.barcode || '').trim()

      const params = {}
      if (key === 'productContentId' && productContentId) {
        params.productContentId = productContentId
      } else if (key === 'variantBarcodes' && variantBarcodes) {
        params.variantBarcodes = variantBarcodes
      } else if (key === 'productName' && productName) {
        params.productName = productName
        if (brandIds.length > 0) {
          params.brandIds = brandIds.join(',')
        }
      } else if (key === 'brandIds' && brandIds.length > 0) {
        params.brandIds = brandIds.join(',')
      } else if (key === 'barcode' && barcode) {
        params.barcode = barcode
      } else {
        Vue.swal({
          title: 'Gecersiz Arama',
          icon: 'warning',
          text: 'Lutfen gecerli bir arama kriteri giriniz.',
        })
        context.commit('setShow', false)
        return
      }
      params.page = context.state.pagination.current_page - 1
      params.size = context.state.pagination.per_page

      const baseUrl = context.state.baseUrl || ''
      const token = await context.dispatch('kigagu/ensureToken', null, { root: true })
      if (!token) {
        context.commit('setShow', false)
        return
      }

      const refreshToken = context.rootGetters['store/_stores']?.find(s => s.id === 24)?.refresh_token_2

      if (!refreshToken) {
        Vue.swal({
          title: 'Token Hatasi',
          icon: 'error',
          text: 'Store id 24 icin refresh token bulunamadi.',
        })
        context.commit('setShow', false)
        return
      }

      try {
        const res = await axiosKigagu.post(`${baseUrl}/export/product/search-by-params/trendyol`,
          params,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'x-ty-code': refreshToken,
            },
          })
        const { data } = res
        context.commit('setContent', data.content)
        if (data.aggregations) {
          context.commit('setBrands', data.aggregations.brand)
          context.commit('setCategories', data.aggregations.category)
        }
        context.commit('setPagination', {
          current_page: data.page + 1,
          per_page: data.size,
          total: data.totalElements,
          last_page: data.totalPages,
          from: data.page * data.size + 1,
          to: data.page * data.size + data.content.length,
        })
        context.dispatch('tyBarcodeChecker')
        context.commit('setShow', false)
      } catch (error) {
        const statusCode = error?.response?.status
        Vue.swal({
          title: statusCode === 401 ? 'Yetki Hatasi' : 'Istek Hatasi',
          icon: 'error',
          text: statusCode === 401
            ? 'API istegi 401 dondu. Gecersiz veya suresi dolmus token olabilir.'
            : 'API istegi basarisiz oldu. Lutfen tekrar deneyiniz.',
        })
        context.commit('setCheckedBarcodes', [])
        context.commit('setShow', false)
      }
    },
    tyBarcodeChecker(context) {
      const barcodes = context.getters._contentBarcodes
      if (barcodes.length === 0) {
        Vue.swal({
          title: 'Barkod Bulunamadi',
          icon: 'warning',
          text: 'Kontrol edilecek barkod bulunamadi. Lutfen önce ürün arama yapiniz.',
        })
        return
      }

      axios.post('/trendyol/create-product/barcode-check', { barcodes })
        .then(res => {
          const { data } = res
          if (data && data.content) {
            context.commit('setCheckedBarcodes', data.content)
          }
        })
        .catch(error => {
          Vue.swal({
            title: 'Istek Hatasi',
            icon: 'error',
            text: 'Barkod kontrol istegi basarisiz oldu. Lutfen tekrar deneyiniz.',
          })
        })
    },
    clearSearch(context) {
      context.commit('setSearchForm', {
        productContentId: '',
        variantBarcodes: '',
        productName: '',
      })
      context.commit('setCheckedBarcodes', [])
    },
  },
}
